import ConfigurableBackground from './_configurable-background.js'
import ConfigurableBorder from './_configurable-border.js'
import AbsolutePane from './_absolute-pane.js'
import Overlay from './_overlay.js'
import HideablePane from './_hideable-pane.js'
import Button from './_button.js'

export default {
  name: 'Popup',
  values: {
    style: {
      zIndex: 601,
      scrim: {
        cursor: 'default',
        $mixin: [
          {
            configSet: ConfigurableBackground,
          },
          {
            configSet: ConfigurableBorder,
          },
        ],
      },
    },
    isOverlayMode: false,
    container: {
      configSet: AbsolutePane,
      configValues: {},
    },
    overlayContainer: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          top: '0px',
          width: '100%',
        },
      },
    },
    overlay: {
      configSet: Overlay,
      configValues: {},
    },
    content: {
      configSet: HideablePane,
      configValues: {
        style: {
          base: {
            padding: '8px',
            boxSizing: 'border-box',
          },
          visible: {
            transform: 'translateY(0px)',
          },
        },
        createStackingContext: true,
      },
    },
    clickBlocker: {
      configSet: Button,
      configValues: {},
    },
    captureOutsideClicks: true,
    showArrowHead: true,
    arrowhead: {
      size: '16px',
      direction: 'down',
    },
    arrowheadOffset: '8px',
    arrowheadHeight: undefined,
    scrimContainer: {
      configSet: HideablePane,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
